import { createClient, type SupabaseClient } from '@supabase/supabase-js';

import type { Database } from './database.types';
import { env } from './env';

export type DdmSupabaseClient = SupabaseClient<Database>;

const SUPABASE_AUTH_OPTIONS = {
  persistSession: true,
  autoRefreshToken: true,
  detectSessionInUrl: true,
} as const;

export function createSupabaseClient(url: string, anonKey: string): DdmSupabaseClient {
  return createClient<Database>(url, anonKey, { auth: SUPABASE_AUTH_OPTIONS });
}

let client: DdmSupabaseClient | undefined;

export function getSupabaseClient(): DdmSupabaseClient {
  if (client) return client;
  const { url, anonKey } = env.supabase;
  if (!url || !anonKey) {
    throw new Error(
      'Supabase client not configured: set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in .env.local',
    );
  }
  client = createSupabaseClient(url, anonKey);
  return client;
}
